export const FACILITY_ID = /^[0-9A-Z-]+$/;

export const HEXADECIMAL = /^[0-9a-f]+$/;

export const EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
